import { createSlice } from '@reduxjs/toolkit';


const initialState = {
    buttons : false,
    buttonsText: {}
}

const bannerslice = createSlice({
    name: 'button',
    initialState: initialState,
    reducers: {
        setButtonsData : (state, action) => {
            state.buttons = action.payload
        },
        setButtonsText: (state, action) => {
            state.buttonsText = action.payload
        }
     }
    })
export const { setButtonsData, setButtonsText } = bannerslice.actions;
export default bannerslice.reducer